<template>
  <div class="SecurityGroupSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="6">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('RAM.common.PleaseSelectCompany')"
            :transfer="true"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
            >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="6">
        <Input
          v-model="accountName"
          :placeholder="$t('RAM.common.filterByAccountName')"
        />
      </Col>
      <Col span="6">
        <Input
          v-model="repositoryName"
          :placeholder="$t('RAM.AWS.ECR.enterRepositoryName')"
        />
      </Col>
      <Col span="4">
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:ecr:page'
          ]"
          @click="getData"
        >{{ $t("message.select") }}</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import { getCookie } from "../../../../../utils/cookieUtil.js";
import TableECR from "../ecr/TableECR";
var tableSecurityGroup = TableECR;
export default {
  name: "EcrSearch",
  data() {
    return {
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      accountName: "",
      repositoryName: ""
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    } else {
      this.companyId = this.company;
    }
  },
  methods: {
    getData() {
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("accountName", this.accountName);
      eventBus.$emit("repositoryName", this.repositoryName);
      tableSecurityGroup.methods.showAll();
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    }
  }
};
</script>
<style scoped>
.SecurityGroupSearch {
  padding: 4px 0px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/ecr/ECRSearch.vue